/**
 * Medición por concesionaria (2026-10-07): cuánto tardan en levantar lo que
 * se les observa, cuánto tarda la aprobación, cuántos rechazos y cuántas
 * vuelven en la siguiente inspección. Sale del historial de cada observación.
 */
import { rec_React as React, rec_api as api, rec_puedeAccion as puedeAccion } from "../../runtime/index.jsx";
import "../observaciones/observaciones.css";

// runtime/index.jsx importa este archivo antes de definir React (import circular).
const useEffect = (...a) => React.useEffect(...a);
const useState = (...a) => React.useState(...a);

const RANGOS = [
  { dias: 30, label: `30 días` },
  { dias: 90, label: `90 días` },
  { dias: 365, label: `1 año` },
];

function horas(h) {
  if (h == null) return `—`;
  if (h < 1) return `${Math.round(h * 60)} min`;
  if (h < 48) return `${h.toLocaleString(`es-PE`, { maximumFractionDigits: 1 })} h`;
  return `${(h / 24).toLocaleString(`es-PE`, { maximumFractionDigits: 1 })} días`;
}

export function MedicionConcesionarias() {
  const permitido = puedeAccion(`inspecciones.actas.analitica`);
  const [dias, setDias] = useState(90);
  const [filas, setFilas] = useState(null);
  const [oculto, setOculto] = useState(false);

  useEffect(() => {
    if (!permitido) return;
    const desde = new Date(Date.now() - dias * 864e5).toISOString().slice(0, 10);
    api(`/inspecciones/observaciones/medicion?desde=${desde}`, { sinCache: true })
      .then(setFilas)
      .catch(() => setOculto(true));
  }, [dias, permitido]);

  if (!permitido || oculto) return null;
  return (
    <section className="ob-medicion">
      <div className="ob-medicion-cab">
        <h2>Concesionarias: levantamiento de observaciones</h2>
        <div className="ob-rangos">
          {RANGOS.map((r) => (
            <button key={r.dias} type="button" className={dias === r.dias ? `ob-activo` : ``} onClick={() => setDias(r.dias)}>{r.label}</button>
          ))}
        </div>
      </div>
      {!filas ? (
        <p className="ob-nota">Cargando…</p>
      ) : !filas.length ? (
        <p className="ob-nota">Sin observaciones a concesionarias en este período.</p>
      ) : (
        <div className="ob-tabla-envoltura">
          <table className="ob-tabla">
            <thead>
              <tr>
                <th>Concesionaria</th>
                <th title="Encontradas en el período">Observ.</th>
                <th>Por levantar</th>
                <th>Vencidas</th>
                <th>Por aprobar</th>
                <th>Aprobadas</th>
                <th title="Levantamientos rechazados por el encargado">Rechazos</th>
                <th title="Rechazadas que volvieron en la siguiente inspección">Volvieron</th>
                <th title="Desde que se encontró hasta el primer levantamiento">Tarda en levantar</th>
                <th title="Desde que se levantó hasta que se aprobó o rechazó">Tarda la aprobación</th>
                <th title="Desde que se encontró hasta que se aprobó">Total hasta aprobar</th>
                <th title="Aprobadas sin ningún rechazo">Al primer intento</th>
                <th title="Levantadas (la primera vez) hasta el día del plazo">A tiempo</th>
                <th title="Desde el aviso por WhatsApp/correo hasta el primer levantamiento">Respuesta tras el aviso</th>
                <th title="Vencidas que se escalaron al jefe">Escaladas</th>
              </tr>
            </thead>
            <tbody>
              {filas.map((f) => (
                <tr key={f.concesionariaId}>
                  <td className="ob-nombre">{f.concesionaria}</td>
                  <td>{f.observaciones}</td>
                  <td>{f.porLevantar}</td>
                  <td className={f.vencidas ? `ob-mal` : ``}>{f.vencidas}</td>
                  <td>{f.porAprobar}</td>
                  <td>{f.aprobadas}</td>
                  <td className={f.rechazos ? `ob-mal` : ``}>{f.rechazos}</td>
                  <td>{f.volvieron}</td>
                  <td>{horas(f.horasHastaLevantar)}</td>
                  <td>{horas(f.horasHastaDecidir)}</td>
                  <td>{horas(f.horasHastaAprobar)}</td>
                  <td>{f.aprobadasAlPrimerIntento == null ? `—` : `${f.aprobadasAlPrimerIntento}%`}</td>
                  <td className={f.levantadasATiempo != null && f.levantadasATiempo < 90 ? `ob-mal` : ``}>{f.levantadasATiempo == null ? `—` : `${f.levantadasATiempo}%`}</td>
                  <td>{horas(f.horasDesdeAviso)}</td>
                  <td className={f.escaladas ? `ob-mal` : ``}>{f.escaladas}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
}
